import type { AuthUser } from "../types";

const fallbackDisplayName = "管理员";

/** 解析当前用户在页面上展示的姓名。 */
export function resolveAuthUserDisplayName(user: AuthUser | null | undefined): string {
  return (
    user?.displayName?.trim() ||
    user?.realname?.trim() ||
    user?.nickname?.trim() ||
    user?.username?.trim() ||
    fallbackDisplayName
  );
}

/** 解析当前用户头像文字；后续若有头像 URL 字段，可在布局层替换为图片头像。 */
export function resolveAuthUserAvatarText(user: AuthUser | null | undefined): string {
  return Array.from(resolveAuthUserDisplayName(user))[0] ?? "管";
}

/** 解析当前用户在顶部用户区展示的基础身份标签。 */
export function resolveAuthUserRoleLabel(user: AuthUser | null | undefined): string {
  if (!user) {
    return "管控中心";
  }
  if (user.isSuperuser) {
    return "超级管理员";
  }
  if (user.roles.length > 0) {
    return user.roles.join(" / ");
  }
  if (user.isStaff) {
    return "员工账号";
  }
  return "无角色账号";
}
